var _path, _path2, _rect, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBody(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 91,
    viewBox: "0 0 115 91",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.0737 21.6667L56.921 21L55.4181 21.3442L55.6234 22.2408L45.0078 72.6652L46.5166 72.9828L56.4443 25.8256L66.982 71.8397L68.4849 71.4955L57.202 22.2268L57.3094 21.7164L57.0737 21.6667Z",
    fill: "#7ABB5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.4964 46.3796L75.8418 46.2817L75.6718 45.6819L75.8195 45.0941L75.4811 45.009L75.4213 44.7983L75.0554 44.902L40.5539 36.2285L40.178 37.7238L72.0829 45.7446L38.9994 55.1221L39.4199 56.6055L75.0793 46.4978L75.4436 46.5894L75.4964 46.3796Z",
    fill: "#7ABB5C"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 113,
    height: 59,
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77 1L77 91",
    stroke: "#7ABB5C",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M114 1L114 61",
    stroke: "#BB785C",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M115 1L-4.76837e-07 1",
    stroke: "#E9B80A",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M38 0L38 91",
    stroke: "#1896DC",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M37 90L78 90",
    stroke: "#BB5CA0",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBody);
export default __webpack_public_path__ + "static/media/body.2f35c460c70bebab6fb9f9c2b7a613ed.svg";
export { ForwardRef as ReactComponent };